import * as React from "react";
const IconRoundBoxCheck = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M57 2H7C4.2 2 2 4.2 2 7v50c0 2.8 2.2 5 5 5h50c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5m3 55c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3h50c1.7 0 3 1.3 3 3z" />
    <path d="M48.4 19.7 25.9 42.2 15.6 32c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l11 11c.2.2.4.3.7.3s.5-.1.7-.3l23.3-23.3c.4-.4.4-1 0-1.4s-1.1-.4-1.5 0" />
  </svg>
);
export default IconRoundBoxCheck;
